import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';
export function toDoList(_x, _x2, _x3) {
  return _toDoList.apply(this, arguments);
}
function _toDoList() {
  _toDoList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(page, limit, param) {
    var data;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          data = {
            currentNo: page,
            pageSize: limit,
            // query:param.query,
            // emergency:param.emergency,
            // cateId:param.cateId,
            formName: param.title,
            beginTime: param.startTime,
            endTime: param.endTime,
            category: param.category
          };
          return _context.a(2, request("/flowable/task/todoList", METHOD.POST, data));
      }
    }, _callee);
  }));
  return _toDoList.apply(this, arguments);
}